// extracted by mini-css-extract-plugin
export default {"ClientScorePortletStub":"index__ClientScorePortletStub__MisqN"};